import React from 'react';
import {prependDigitalAssetsUrl} from 'Utils/prependDigitalAssetsUrl';
import PropTypes from 'prop-types';

const LocationImage = ({name, imageUrl, buttons = false}) => (
    <div className="content-hero-img">
        {buttons && (
            <div className="btn-group">
                <div>{buttons.backButton}</div>
                <div>{buttons.closeButton}</div>
            </div>
        )}
        <img
            src={
                imageUrl ? prependDigitalAssetsUrl(imageUrl) : 'images/location-no-image-large.jpg'
            }
            alt={name}
            className="hero-image"
        />
    </div>
);

LocationImage.propTypes = {
    name: PropTypes.string,
    imageUrl: PropTypes.string,
    buttons: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};

export default LocationImage;
